import PageProtected from '../../../components/Page/PageProtected';
import Grid from '@mui/material/Grid';
//import Stack from '@mui/material/Stack';


export default function ClockWelcome() {
   
    return (
    <>
    
    <PageProtected
    
            headline="Epigenetic Clock"
            main={<>

                <Grid container sx={{display:'flex', justifyContent: 'center'}}>
                    
                </Grid>   
            </>}
    />

</>
)}